var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76632 19.0871C7.65448 17.7123 5.69165 16.0993 3.91266 14.2768C2.65533 12.9562 1.69816 11.3539 1.11267 9.58965C0.0687642 6.15375 1.28829 2.22555 4.72243 1.06657C5.6122 0.766307 6.55738 0.69436 7.47902 0.856736C8.40065 1.01911 9.27195 1.41106 10.02 1.99988C10.7669 1.4127 11.6365 1.02165 12.5563 0.859302C13.476 0.696954 14.4194 0.768039 15.3078 1.06657C18.7419 2.22555 19.9712 6.19477 18.9273 9.58965C18.3465 11.3562 17.3887 12.9596 16.1273 14.2768C14.3483 16.0993 12.3855 17.7123 10.2737 19.0871L10.0492 19.2307L9.76632 19.0871Z",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartLine);
export default __webpack_public_path__ + "static/media/heartLine.f73031f0b83906e92e50e199949544ff.svg";
export { ForwardRef as ReactComponent };